// Helper to manage navigation stack
export const NavigationTracker = {
  getStack: () => {
    const stack = sessionStorage.getItem('navStack');
    return stack ? JSON.parse(stack) : [];
  },
  push: (path: string) => {
    const stack = NavigationTracker.getStack();
    if (stack[stack.length - 1] !== path) {
      stack.push(path);
      sessionStorage.setItem('navStack', JSON.stringify(stack));
    }
  },
  pop: () => {
    const stack = NavigationTracker.getStack();
    if (stack.length > 1) {
      const newStack = stack.slice(0, -1);
      sessionStorage.setItem('navStack', JSON.stringify(newStack));
      return stack[stack.length - 2]; // Return previous path
    }
    return '/'; // Fallback to home
  }
};